import Swiper from "swiper";
import {Navigation, Thumbs} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/thumbs';

let galleryThumbs;
let thumbsOptions = {};

if (document.querySelector(".product-gallery__thumbs")) {
    galleryThumbs = new Swiper(".product-gallery__thumbs", {
        spaceBetween: 16,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
    });

    thumbsOptions = {
        swiper: galleryThumbs,
    };
}

const productGallery = new Swiper(".product-gallery__gallery", {
    modules: [Navigation, Thumbs],
    autoHeight: true,
    spaceBetween: 0,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    thumbs: thumbsOptions,
});